<op-basic-single-date-picker [id]="'values-' + filter.id"
  [name]="'v[' + filter.id + ']'"
  class="advanced-filters--date-field"
  required="true"

  (valueChange)="value = isoDateParser($event)"
  [value]="isoDateFormatter(value)"

  [opAutofocus]="shouldFocus"
 />

@if (isTimeZoneDifferent) {
  <span
    class="advanced-filters--tooltip-trigger -multiline"
    [attr.data-tooltip]="timeZoneText"
    >
    <svg alert-icon size="small" />
  </span>
}
